import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { Col, PageHeader, Row, Spin, Tabs, Tag, Drawer, message, Descriptions } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import {
    ButtonItem,
    RangePickerItem,
    TableItem,
    SelectItem,
    InputItem,
} from "../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../Components/SelectEmpresasBiwoItem";

moment.locale("es");

const { TabPane } = Tabs;

// Cuántos renglones se traen de golpe.
//
// `TableItem` fija su propio `pagination` y NO reenvía el prop, así que la paginación
// del servidor no se puede manejar desde la tabla. Se trae un bloque y se pagina en
// cliente, igual que Performance. Si `total` es mayor, se avisa para que afinen el
// filtro en vez de mostrar datos incompletos en silencio.
const TAM_BLOQUE = 500;

const MODULOS = [
    "venta", "puntoVenta", "kiosko", "cotizacion", "pedido", "embarque",
    "consignacion", "devolucion", "notaCreditoVenta", "notaCreditoAnticipo",
    "notaCredito-facturaGlobal", "complementoPago", "complementoPago-varias",
    "complementoPago-puntoVenta", "cartaPorte", "cartaTrasladoRemision",
    "ventaProgramada", "ventaBiwo", "woocommerce", "nomina", "nomina-historica",
    "cancelacion", "cancelacion-venta", "cancelacion-facturaGlobal",
    "cancelacion-notaCreditoVenta", "cancelacion-complementoPago",
    "cancelacion-cartaPorte", "cancelacion-devolucion", "cancelacion-nomina",
    "cancelacion-refacturar", "cancelacion-woocommerce", "cancelacion-xmlDescargado",
];

const colorTipo = (tipo) =>
    (tipo === "datos" ? "green" : tipo === "sistema" ? "red" : "orange");

class ErroresTimbrado extends Component {
    state = {
        activeTab: "rechazos",
        rango: [moment().subtract(7, "days"), moment()],
        empresaId: undefined,
        modulo: undefined,
        tipo: undefined,
        codigo: "",
        idRastreo: "",
        soloSinCurar: false,

        loadingLista: false,
        lista: [],
        total: 0,

        loadingCodigos: false,
        codigos: [],

        resumen: null,

        drawerVisible: false,
        detalle: null,
    };

    componentDidMount() {
        this.consultarTodo();
    }

    filtros() {
        const { rango, empresaId, modulo, tipo, codigo, idRastreo, soloSinCurar } = this.state;
        return {
            desde: rango?.[0] ? rango[0].toISOString() : undefined,
            hasta: rango?.[1] ? rango[1].toISOString() : undefined,
            empresaId,
            modulo,
            tipo,
            codigo: codigo?.trim() || undefined,
            idRastreo: idRastreo?.trim() || undefined,
            soloSinCurar: soloSinCurar || undefined,
        };
    }

    consultarTodo = () => {
        this.consultarLista();
        this.consultarCodigos();
        this.consultarResumen();
    };

    consultarLista = () => {
        this.setState({ loadingLista: true });
        axios
            .post("erroresTimbrado/listar", { ...this.filtros(), pageSize: TAM_BLOQUE },
                { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({ lista: res.data.data || [], total: res.data.total || 0 });
                } else {
                    message.error(res.data.message || "No se pudieron consultar los rechazos");
                }
            })
            .catch(() => message.error("Error de conexión al consultar los rechazos"))
            .finally(() => this.setState({ loadingLista: false }));
    };

    consultarCodigos = () => {
        this.setState({ loadingCodigos: true });
        axios
            .post("erroresTimbrado/porCodigo", this.filtros(), { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ codigos: res.data.data || [] });
            })
            .catch(() => {})
            .finally(() => this.setState({ loadingCodigos: false }));
    };

    consultarResumen = () => {
        axios
            .post("erroresTimbrado/resumen", this.filtros(), { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ resumen: res.data });
            })
            .catch(() => {});
    };

    columnasLista = [
        {
            title: "Fecha",
            dataIndex: "createdAt",
            key: "createdAt",
            width: 140,
            render: (v) => moment(v).format("DD/MM/YY HH:mm"),
        },
        {
            title: "Código",
            dataIndex: "codigo",
            key: "codigo",
            width: 110,
            render: (v, r) => (
                <>
                    <div>{v || <i style={{ color: "#999" }}>sin código</i>}</div>
                    <Tag color={colorTipo(r.tipo)} style={{ marginTop: 2 }}>{r.tipo}</Tag>
                </>
            ),
        },
        { title: "Módulo", dataIndex: "modulo", key: "modulo", width: 150 },
        { title: "Folio", dataIndex: "folio", key: "folio", width: 100 },
        {
            title: "Mensaje que vio el usuario",
            dataIndex: "mensaje",
            key: "mensaje",
            render: (v) => (
                <span style={{ whiteSpace: "pre-line" }}>
                    {String(v || "").split("\n")[0]}
                </span>
            ),
        },
        { title: "Rastreo", dataIndex: "idRastreo", key: "idRastreo", width: 100 },
    ];

    columnasCodigos = [
        {
            title: "Código",
            dataIndex: "codigo",
            key: "codigo",
            width: 120,
            render: (v, r) => (
                <>
                    <div>{v || <i style={{ color: "#999" }}>sin código</i>}</div>
                    <Tag color={colorTipo(r.tipo)} style={{ marginTop: 2 }}>{r.tipo}</Tag>
                </>
            ),
        },
        { title: "Veces", dataIndex: "total", key: "total", width: 80 },
        { title: "Empresas", dataIndex: "empresas", key: "empresas", width: 90 },
        { title: "Fuente", dataIndex: "fuente", key: "fuente", width: 180 },
        { title: "Campo", dataIndex: "atributo", key: "atributo", width: 160 },
        {
            // La razón de ser de esta pestaña: un código frecuente sin mensaje a mano es,
            // literalmente, el siguiente renglón a redactar en erroresTimbradoMensajes.js.
            title: "¿Mensaje propio?",
            dataIndex: "curado",
            key: "curado",
            width: 150,
            render: (curado, r) =>
                (curado
                    ? <Tag color="green">Sí</Tag>
                    : <Tag color={r.total >= 10 ? "red" : "default"}>
                        {r.total >= 10 ? "Falta, y sale mucho" : "No"}
                    </Tag>),
        },
        {
            title: "Lo que hoy lee el usuario",
            dataIndex: "mensajeActual",
            key: "mensajeActual",
            render: (v) => <span style={{ color: v ? undefined : "#999" }}>{v || "—"}</span>,
        },
        {
            title: "Último",
            dataIndex: "ultimoVisto",
            key: "ultimoVisto",
            width: 120,
            render: (v) => moment(v).format("DD/MM/YY HH:mm"),
        },
    ];

    render() {
        const {
            activeTab, rango, lista, total, loadingLista, codigos, loadingCodigos,
            resumen, drawerVisible, detalle,
        } = this.state;

        return (
            <>
                <PageHeader
                    title="Rechazos del PAC"
                    subTitle="Los errores de timbrado que el SAT devolvió, de todas las empresas"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            <RangePickerItem
                                showTime={{ format: "HH:mm" }}
                                format="DD/MM/YYYY HH:mm"
                                value={rango}
                                onChange={(r) => this.setState({ rango: r })}
                                allowClear
                                /* El ancho va por el prop propio: RangePickerItem hace
                                   {...this.props} DESPUÉS de style. */
                                width={360}
                                ranges={{
                                    "Últimas 24 hrs": [moment().subtract(24, "hours"), moment()],
                                    "Últimos 7 días": [moment().subtract(7, "days"), moment()],
                                    "Últimos 30 días": [moment().subtract(30, "days"), moment()],
                                    "Los 90 días": [moment().subtract(90, "days"), moment()],
                                }}
                            />
                            <ButtonItem
                                type="primary"
                                icon={<ReloadOutlined />}
                                onClick={this.consultarTodo}
                            >
                                Refrescar
                            </ButtonItem>
                        </>
                    }
                />

                {resumen && (
                    <Row gutter={8} style={{ marginBottom: 10 }}>
                        <Col span={6}>
                            <div style={tarjeta}>
                                <div style={etiqueta}>Rechazos</div>
                                <div style={numero}>{resumen.total}</div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div style={tarjeta}>
                                <div style={etiqueta}>De datos (los corrige el usuario)</div>
                                <div style={{ ...numero, color: "#389e0d" }}>{resumen.datos}</div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div style={tarjeta}>
                                <div style={etiqueta}>De sistema</div>
                                <div style={{ ...numero, color: "#cf1322" }}>{resumen.sistema}</div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div style={tarjeta}>
                                <div style={etiqueta}>Sin clasificar</div>
                                <div style={{ ...numero, color: "#d46b08" }}>{resumen.desconocido}</div>
                            </div>
                        </Col>
                    </Row>
                )}

                <div style={{ backgroundColor: "white", padding: 10, borderRadius: 5, marginBottom: 10 }}>
                    <Row gutter={8}>
                        <Col span={6}>
                            <SelectEmpresasBiwoItem
                                onChange={(empresaId) => this.setState({ empresaId })}
                            />
                        </Col>
                        <Col span={5}>
                            {/* Por el prop `options`, no por children: SelectItem no
                                expone un `.Option` propio. */}
                            <SelectItem
                                placeholder="Módulo"
                                allowClear
                                onChange={(modulo) => this.setState({ modulo })}
                                width="100%"
                                options={MODULOS.map((m) => ({ value: m, label: m }))}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectItem
                                placeholder="Tipo"
                                allowClear
                                onChange={(tipo) => this.setState({ tipo })}
                                width="100%"
                                options={[
                                    { value: "datos", label: "datos" },
                                    { value: "sistema", label: "sistema" },
                                    { value: "desconocido", label: "desconocido" },
                                ]}
                            />
                        </Col>
                        <Col span={4}>
                            <InputItem
                                placeholder="Código (CFDI40147)"
                                onChange={(e) => this.setState({ codigo: e.target.value })}
                            />
                        </Col>
                        <Col span={3}>
                            <InputItem
                                placeholder="TMB-XXXXX"
                                onChange={(e) => this.setState({ idRastreo: e.target.value })}
                            />
                        </Col>
                        <Col span={2}>
                            <ButtonItem type="primary" block onClick={this.consultarTodo}>
                                Buscar
                            </ButtonItem>
                        </Col>
                    </Row>
                </div>

                {/* Tabs por children y no por `items`: esa API llegó en antd 4.23 y aquí
                    hay 4.15.6. */}
                <Tabs
                    activeKey={activeTab}
                    onChange={(k) => this.setState({ activeTab: k })}
                    style={{ backgroundColor: "white", padding: "0 15px", borderRadius: 5 }}
                >
                    <TabPane tab="Rechazos" key="rechazos">
                        {total > lista.length && (
                            <div style={{ padding: "6px 0", color: "#d46b08" }}>
                                Hay {total} rechazos y se están mostrando los {lista.length} más
                                recientes. Afina el filtro para ver el resto.
                            </div>
                        )}
                        <Spin spinning={loadingLista}>
                            <TableItem
                                dataSource={lista}
                                columns={this.columnasLista}
                                rowKey={(r) => r._id}
                                size="small"
                                onRow={(registro) => ({
                                    onClick: () =>
                                        this.setState({ drawerVisible: true, detalle: registro }),
                                })}
                            />
                        </Spin>
                    </TabPane>

                    <TabPane tab="Por código" key="codigos">
                        <Spin spinning={loadingCodigos}>
                            <TableItem
                                dataSource={codigos}
                                columns={this.columnasCodigos}
                                rowKey={(r) => `${r.codigo}-${r.fuente}`}
                                size="small"
                            />
                        </Spin>
                    </TabPane>
                </Tabs>

                <Drawer
                    title={detalle ? `${detalle.codigo || "Sin código"} · ${detalle.idRastreo}` : ""}
                    visible={drawerVisible}
                    onClose={() => this.setState({ drawerVisible: false })}
                    width={640}
                >
                    {detalle && (
                        <>
                            <p style={{ whiteSpace: "pre-line", marginBottom: 16 }}>
                                <b>{detalle.titulo}</b>
                                {"\n\n"}
                                {detalle.mensaje}
                            </p>

                            <Descriptions size="small" column={1} bordered>
                                <Descriptions.Item label="Tipo">
                                    <Tag color={colorTipo(detalle.tipo)}>{detalle.tipo}</Tag>
                                </Descriptions.Item>
                                <Descriptions.Item label="Módulo">{detalle.modulo || "—"}</Descriptions.Item>
                                <Descriptions.Item label="Fuente">{detalle.fuente || "—"}</Descriptions.Item>
                                <Descriptions.Item label="Campo">{detalle.atributo || "—"}</Descriptions.Item>
                                <Descriptions.Item label="Folio">{detalle.folio || "—"}</Descriptions.Item>
                                <Descriptions.Item label="RFC receptor">{detalle.receptorRfc || "—"}</Descriptions.Item>
                                <Descriptions.Item label="Documento">
                                    {detalle.documentoId || <i>sin guardar (el PAC se llama antes de crearlo)</i>}
                                </Descriptions.Item>
                                <Descriptions.Item label="Servidor">{detalle.servidor || "—"}</Descriptions.Item>
                                <Descriptions.Item label="HTTP">{detalle.httpStatus || "—"}</Descriptions.Item>
                            </Descriptions>

                            <p style={{ marginTop: 16, marginBottom: 4, fontWeight: 600 }}>
                                Lo que contestó el PAC
                            </p>
                            <pre style={preDetalle}>{detalle.detalleTecnico}</pre>
                        </>
                    )}
                </Drawer>
            </>
        );
    }
}

const tarjeta = {
    backgroundColor: "white",
    borderRadius: 5,
    padding: "10px 14px",
    border: "1px solid rgb(235, 237, 240)",
};
const etiqueta = { fontSize: 12, color: "rgba(0,0,0,0.45)" };
const numero = { fontSize: 24, fontWeight: 600 };
const preDetalle = {
    background: "#fafafa",
    border: "1px solid #f0f0f0",
    borderRadius: 6,
    padding: "8px 10px",
    fontSize: 12,
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
};

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ErroresTimbrado);
